'use client';

import { Logo } from '@/assets';
import { Skeleton, Switch } from '@/components/ui';
import { useToggle, useViewport } from '@/hooks';
import { useMount } from '@/hooks/use-mount';
import { AnimatePresence } from 'motion/react';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import { MobileNavbar, Navbar } from './navbar';

const Hamburger = dynamic(() => import('../ui/hamburger/hamburger').then((mod) => mod.Hamburger));

export const Header = () => {
  const { mount } = useMount();
  const [isMenuOpen, toggleMenu] = useToggle();
  const { isMobile } = useViewport();

  return (
    <header className="flex items-center justify-between" id="header">
      <Link className="z-50" href="/" aria-label="Home Page Link for design by nidhi">
        <Logo className="h-auto w-28 sm:w-[173px]" />
      </Link>
      {mount && isMobile ? (
        <AnimatePresence mode="wait">{isMenuOpen && <MobileNavbar {...{ toggleMenu }} />}</AnimatePresence>
      ) : (
        <Navbar />
      )}
      <div className="z-40 flex items-center space-x-3">
        {mount ? <Switch /> : <Skeleton className="h-[40px] w-[76px] rounded-full" />}
        {isMobile && <Hamburger isOpen={isMenuOpen} onClick={toggleMenu} />}
      </div>
    </header>
  );
};
